













	// @ts-ignore
    import _ from './MPager.ts'; export default _;
